import React, { useState, memo } from 'react';
import { Tooltip, IconButton, useTheme } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { ElementPropertiesDialog } from './elementPropertiesDialog';

export const ElementButtonEdit = memo(({ canvasRef, color, item, type }) => {
  const [showElementProperties, setShowElementProperties] = useState(false);
  const theme = useTheme();

  return (
    <>
      <Tooltip title="Edit node">
        <IconButton size="small" onClick={() => setShowElementProperties(true)} sx={{ color: theme.palette.common.white }}>
          <EditIcon sx={{ fontSize: 15, color: color || theme.palette.common.white }} />
        </IconButton>
      </Tooltip>
      <ElementPropertiesDialog open={showElementProperties} setOpen={setShowElementProperties} item={item} type={type}></ElementPropertiesDialog>
    </>
  );
});